import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddEmailSettings1754369674672 implements MigrationInterface {
	name = 'AddEmailSettings1754369674672'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" ADD "email" json`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "email"`)
	}
}
